import { Button, CircularProgress, Grid, TextField } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { Autocomplete } from "@material-ui/lab";
import { debounce } from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import * as actions from "../../CargoCargoMatrix/actions";
import { allVesselsByCharWithoutReducer } from "../actions";
import { getVesselManagerAPI } from "../api";
import VesselViewModel from "../Contracts/VesselViewModel";

import moment from "moment";
import CustomAddModal from "../../../../components/Common/CustomAddModal";
import ShareWithOrg from "../../../../components/Common/ShareWithOrg";
import { termsCoEfficientTable } from "../../../../constants";
import { getCurrentUserOrganizationId, toastSuccess } from "../../../../utils";
import { addCargoCargoDetails } from "../../Orders/actions";
import ActionButtonsCargoCargo from "./ActionButtonsCargoCargo";
import CargoCargoPortOperations from "./CargoCargoPortOperations";
import CargoCargoResult from "./CargoCargoResult";
import CargoDetails from "./CargoDetails";
import Expense from "./Expense";
import NetProfitResult from "./NetProfitResult";
import Revenue from "./Revenue";

const mapVesselConsumptions = (vesselData) => {
  if (!vesselData) return {};

  if (!vesselData.Ballast_Sea_Consumptions && !vesselData.Laden_Sea_Consumptions) {
    return vesselData;
  }

  const ballastConsumptions = vesselData?.Ballast_Sea_Consumptions || {};
  const ladenConsumptions = vesselData?.Laden_Sea_Consumptions || {};

  return {
    vesselBalSpd1: ballastConsumptions.col_1?.Speed || 0,
    vesselBalConsmHS1: ballastConsumptions.col_1?.HS || 0,
    vesselBalConsmLS1: ballastConsumptions.col_1?.LS || 0,
    vesselBalConsmMGO1: ballastConsumptions.col_1?.MGO || 0,
    vesselBalSpd2: ballastConsumptions.col_2?.Speed || 0,
    vesselBalConsmHS2: ballastConsumptions.col_2?.HS || 0,
    vesselBalConsmLS2: ballastConsumptions.col_2?.LS || 0,
    vesselBalConsmMGO2: ballastConsumptions.col_2?.MGO || 0,
    vesselBalSpd3: ballastConsumptions.col_3?.Speed || 0,
    vesselBalConsmHS3: ballastConsumptions.col_3?.HS || 0,
    vesselBalConsmLS3: ballastConsumptions.col_3?.LS || 0,
    vesselBalConsmMGO3: ballastConsumptions.col_3?.MGO || 0,
    vesselBalSpd4: ballastConsumptions.col_4?.Speed || 0,
    vesselBalConsmHS4: ballastConsumptions.col_4?.HS || 0,
    vesselBalConsmLS4: ballastConsumptions.col_4?.LS || 0,
    vesselBalConsmMGO4: ballastConsumptions.col_4?.MGO || 0,

    vesselLdnSpd1: ladenConsumptions.col_1?.Speed || 0,
    vesselLdnConsmHS1: ladenConsumptions.col_1?.HS || 0,
    vesselLdnConsmLS1: ladenConsumptions.col_1?.LS || 0,
    vesselLdnConsmMGO1: ladenConsumptions.col_1?.MGO || 0,
    vesselLdnSpd2: ladenConsumptions.col_2?.Speed || 0,
    vesselLdnConsmHS2: ladenConsumptions.col_2?.HS || 0,
    vesselLdnConsmLS2: ladenConsumptions.col_2?.LS || 0,
    vesselLdnConsmMGO2: ladenConsumptions.col_2?.MGO || 0,
    vesselLdnSpd3: ladenConsumptions.col_3?.Speed || 0,
    vesselLdnConsmHS3: ladenConsumptions.col_3?.HS || 0,
    vesselLdnConsmLS3: ladenConsumptions.col_3?.LS || 0,
    vesselLdnConsmMGO3: ladenConsumptions.col_3?.MGO || 0,
    vesselLdnSpd4: ladenConsumptions.col_4?.Speed || 0,
    vesselLdnConsmHS4: ladenConsumptions.col_4?.HS || 0,
    vesselLdnConsmLS4: ladenConsumptions.col_4?.LS || 0,
    vesselLdnConsmMGO4: ladenConsumptions.col_4?.MGO || 0,
  };
};


export default function CargoCargoMatrixMain(props) {
  const { setLoader = () => { }, setIsFullScreen = () => { } } = props;
  const { id = "" } = useParams();
  const [calculatorData, setCalculatorData] = useState(null);
  const organizationId = getCurrentUserOrganizationId();
  const [openCargoDetails, setOpenCargoDetails] = useState(false);
  const [isCopyConfirm, setCopyConfirm] = useState(false);
  const [getSingleCargoData, setSingleCargoData] = useState("");
  const [shareLabel, setShareLabel] = useState("");
  const cargoDetailsRef = useRef(null);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [isVesselLoading, setIsVesselLoading] = useState(false);
  const vesselManagerDataRef = useRef(null);
  const [selectedVessel, setSelectedVessel] = useState(null);
  const [showVesselModal, setShowVesselModal] = useState(false);
  const [previewVessel, setPreviewVessel] = useState(null);
  const vesselModelRef = useRef(null);

  useEffect(() => {
    getVesselManagerAPI()
      .then((res) => {
        vesselManagerDataRef.current = res?.data?.allVesselManager || {};
      })
      .catch((err) => { });
  }, []);

  const delayVesselSearch = React.useCallback(
    debounce((search) => onSearchVesselList(search), 500),
    []
  );

  const onSearchVesselList = (value) => {
    if (value) {
      setIsVesselLoading(true);
      allVesselsByCharWithoutReducer(value)
        .then((res) => {
          setIsVesselLoading(false);
          setVesselOptions(
            (Array.isArray(res.data.list) &&
              res.data.list.map((item) => {
                let parsed = item;
                try {
                  parsed = item.vessel ? JSON.parse(item.vessel) : item;
                } catch (e) { }
                return {
                  ...item,
                  vesselData: parsed,
                  vesselLabel: `${item.vesselName} (${item.vesselDwt || parsed.vesselDwt || parsed.DWT || parsed.dwt || 0})`,
                };
              })) || [],
          );
        })
        .catch((err) => {
          setIsVesselLoading(false);
        });
    } else {
      setVesselOptions([]);
    }
  };

  const parseDate = (dateStr) => {
    const [date, time] = dateStr?.split(" ");
    const [month, day, year] = date?.split("/");
    return new Date(
      `20${year}-${month?.padStart(2, "0")}-${day?.padStart(2, "0")}T${time}:00`,
    );
  };

  const calculateDifference = (arrivalTime, departureTime) => {
    const arrivalDate = parseDate(moment(arrivalTime).format("M/D/YY HH:mm"));
    const departureDate = parseDate(
      moment(departureTime).format("M/D/YY HH:mm"),
    );
    const timeDiff = departureDate - arrivalDate;
    const diffInDays = timeDiff / (1000 * 60 * 60 * 24);
    return diffInDays.toFixed(9);
  };

  const structureChange = (currentdata) => {
    currentdata?.vesselVoyageData?.map((item) => {
      if (item?.arrivalTime && item?.departureTime) {
        item.portStay = calculateDifference(
          item?.arrivalTime,
          item?.departureTime,
        );
      }
    });
    return currentdata;
  };
  useEffect(() => {
    setIsFullScreen(true);
    if (id) {
      getInitialData(id);
    }
    return () => {
      setIsFullScreen(false);
    };
  }, []);
  const getInitialData = (id) => {
    setLoader(true, "Fetching data...");
    actions
      .getSingleCargoCargoDetails(id)
      .then((res) => {
        setLoader(false);
        const structureData = structureChange(res.data);
        setCalculatorData(structureData);
        calculate(structureData);
      })
      .catch((err) => {
        setLoader(false);
      });
  };

  const calculate = (calculatordata) => {
    const currentdata = { ...calculatordata };
    currentdata.calculateRates = [];

    // Helper to safely parse numbers, handling empty strings and commas (e.g. "12,500" -> 12500)
    const parseNum = (val) => {
      if (val === undefined || val === null || val === "") return 0;
      if (typeof val === "string") {
        const parsed = Number(val.replace(/,/g, ""));
        return isNaN(parsed) ? 0 : parsed;
      }
      const num = Number(val);
      return isNaN(num) ? 0 : num;
    };

    // Calculate dynamic length so we don't truncate at 10 rows or push empty objects
    const maxRows = Math.max(
      currentdata?.vesselVoyageData?.length || 0,
      currentdata?.customerCargo?.cargoList?.length || 0,
      currentdata?.vendorCargo?.cargoList?.length || 0,
      1,
    );

    const isNewCalculation = !currentdata._id || currentdata.createdAt === currentdata.updatedAt;

    for (let i = 0; i < maxRows; i++) {
      let calculateRates = {};

      const voyageData = currentdata?.vesselVoyageData?.[i] || {};
      const customerData = currentdata?.customerCargo?.cargoList?.[i] || {};
      const vendorData = currentdata?.vendorCargo?.cargoList?.[i] || {};

      const actualCargoQty = parseNum(voyageData.actualCargoQty);

      const custRate = parseNum(customerData.rate);
      calculateRates.LaytimeAllowedRevenue =
        custRate > 0 ? actualCargoQty / custRate : 0;

      if (isNewCalculation && !customerData.laytimeIncurred_edited && calculateRates.LaytimeAllowedRevenue > 0) {
        customerData.laytimeIncurred = Number(calculateRates.LaytimeAllowedRevenue.toFixed(3));
      }

      const vendRate = parseNum(vendorData.rate);
      calculateRates.LaytimeAllowedExpense =
        vendRate > 0 ? actualCargoQty / vendRate : 0;

      if (isNewCalculation && !vendorData.laytimeIncurred_edited && calculateRates.LaytimeAllowedExpense > 0) {
        vendorData.laytimeIncurred = Number(calculateRates.LaytimeAllowedExpense.toFixed(3));
      }

      const calcDemurrage = (incurred, allowed, rate) =>
        incurred - allowed >= 0 ? (incurred - allowed) * rate : 0;
      const calcDespatch = (incurred, allowed, rate) =>
        allowed - incurred > 0 ? (allowed - incurred) * rate : 0;

      const custLaytimeIncurred =
        customerData.laytimeIncurred !== undefined && customerData.laytimeIncurred !== "" && customerData.laytimeIncurred !== null
          ? parseNum(customerData.laytimeIncurred)
          : calculateRates.LaytimeAllowedRevenue;
      calculateRates.DemurrageAmtRevenue = calcDemurrage(
        custLaytimeIncurred,
        calculateRates.LaytimeAllowedRevenue,
        parseNum(customerData.demurrageRate),
      );
      calculateRates.DespatchAmtRevenue = calcDespatch(
        custLaytimeIncurred,
        calculateRates.LaytimeAllowedRevenue,
        parseNum(customerData.despatchRate),
      );

      const vendLaytimeIncurred =
        vendorData.laytimeIncurred !== undefined && vendorData.laytimeIncurred !== "" && vendorData.laytimeIncurred !== null
          ? parseNum(vendorData.laytimeIncurred)
          : calculateRates.LaytimeAllowedExpense;
      calculateRates.DemurrageAmtExpense = calcDemurrage(
        vendLaytimeIncurred,
        calculateRates.LaytimeAllowedExpense,
        parseNum(vendorData.demurrageRate),
      );
      calculateRates.DespatchAmtExpense = calcDespatch(
        vendLaytimeIncurred,
        calculateRates.LaytimeAllowedExpense,
        parseNum(vendorData.despatchRate),
      );

      calculateRates.grossFreightAmountRevenue =
        actualCargoQty * parseNum(customerData.freight);
      calculateRates.grossFreightAmountExpense =
        actualCargoQty * parseNum(vendorData.freight);

      const grossRev = calculateRates.grossFreightAmountRevenue;
      calculateRates.adcomAmountRevenue =
        (grossRev * parseNum(customerData.adcom)) / 100;
      calculateRates.othersAmountRevenue =
        (grossRev * parseNum(customerData.other)) / 100;
      calculateRates.brokerageAmountRevenue =
        (grossRev * parseNum(customerData.brokerage)) / 100;

      const grossExp = calculateRates.grossFreightAmountExpense;
      calculateRates.adcomAmountExpense =
        (grossExp * parseNum(vendorData.adcom)) / 100;
      calculateRates.othersAmountExpense =
        (grossExp * parseNum(vendorData.other)) / 100;
      calculateRates.brokerageAmountExpense =
        (grossExp * parseNum(vendorData.brokerage)) / 100;

      calculateRates.netFreightRevenue =
        grossRev -
        calculateRates.adcomAmountRevenue -
        calculateRates.othersAmountRevenue -
        calculateRates.brokerageAmountRevenue;

      calculateRates.netFreightExpense =
        grossExp -
        calculateRates.adcomAmountExpense -
        calculateRates.othersAmountExpense -
        calculateRates.brokerageAmountExpense;

      calculateRates.laytimeRevenueRevenue =
        calculateRates.DemurrageAmtRevenue - calculateRates.DespatchAmtRevenue;
      calculateRates.laytimeRevenueExpense =
        calculateRates.DemurrageAmtExpense - calculateRates.DespatchAmtExpense;

      calculateRates.netRevenue =
        calculateRates.netFreightRevenue +
        calculateRates.laytimeRevenueRevenue +
        parseNum(customerData.additionalRevenue) -
        parseNum(customerData.additionalExpense);

      calculateRates.netExpense =
        calculateRates.netFreightExpense +
        calculateRates.laytimeRevenueExpense +
        parseNum(vendorData.additionalExpense) -
        parseNum(vendorData.additionalRevenue);

      calculateRates.totalNetFreight =
        calculateRates.netFreightRevenue - calculateRates.netFreightExpense;
      calculateRates.totalLaytimeProfit =
        calculateRates.laytimeRevenueRevenue -
        calculateRates.laytimeRevenueExpense;
      calculateRates.netProfit =
        calculateRates.netRevenue - calculateRates.netExpense;
      calculateRates.profitPerUnit =
        actualCargoQty > 0 ? calculateRates.netProfit / actualCargoQty : 0;

      currentdata.calculateRates.push(calculateRates);
    }

    const totalCalculatedRates = {
      totalDemurrageAmtExpense: 0,
      totalDemurrageAmtRevenue: 0,
      totalDespatchAmtExpense: 0,
      totalDespatchAmtRevenue: 0,
      totalGrossFreightAmountExpense: 0,
      totalGrossFreightAmountRevenue: 0,
      totalAdcomAmountExpense: 0,
      totalAdcomAmountRevenue: 0,
      totalOthersAmountExpense: 0,
      totalOthersAmountRevenue: 0,
      totalBrokerageAmountExpense: 0,
      totalBrokerageAmountRevenue: 0,
      totalNetFreightRevenue: 0,
      totalNetFreightExpense: 0,
      totalLaytimeRevenueRevenue: 0,
      totalLaytimeRevenueExpense: 0,
      totalNetRevenue: 0,
      totalNetExpense: 0,
      totalNetFreight: 0,
      totalLaytimeProfit: 0,
      netProfit: 0,
    };

    currentdata.calculateRates.forEach((rate) => {
      totalCalculatedRates.totalDemurrageAmtExpense += rate.DemurrageAmtExpense;
      totalCalculatedRates.totalDemurrageAmtRevenue += rate.DemurrageAmtRevenue;
      totalCalculatedRates.totalDespatchAmtExpense += rate.DespatchAmtExpense;
      totalCalculatedRates.totalDespatchAmtRevenue += rate.DespatchAmtRevenue;
      totalCalculatedRates.totalGrossFreightAmountExpense +=
        rate.grossFreightAmountExpense;
      totalCalculatedRates.totalGrossFreightAmountRevenue +=
        rate.grossFreightAmountRevenue;
      totalCalculatedRates.totalAdcomAmountExpense += rate.adcomAmountExpense;
      totalCalculatedRates.totalAdcomAmountRevenue += rate.adcomAmountRevenue;
      totalCalculatedRates.totalOthersAmountExpense += rate.othersAmountExpense;
      totalCalculatedRates.totalOthersAmountRevenue += rate.othersAmountRevenue;
      totalCalculatedRates.totalBrokerageAmountExpense +=
        rate.brokerageAmountExpense;
      totalCalculatedRates.totalBrokerageAmountRevenue +=
        rate.brokerageAmountRevenue;

      totalCalculatedRates.totalNetFreightRevenue += rate.netFreightRevenue;
      totalCalculatedRates.totalNetFreightExpense += rate.netFreightExpense;
      totalCalculatedRates.totalLaytimeRevenueRevenue +=
        rate.laytimeRevenueRevenue;
      totalCalculatedRates.totalLaytimeRevenueExpense +=
        rate.laytimeRevenueExpense;
      totalCalculatedRates.totalNetFreight += rate.totalNetFreight;
      totalCalculatedRates.totalLaytimeProfit += rate.totalLaytimeProfit;
    });
    totalCalculatedRates.totalNetRevenue =
      Number(totalCalculatedRates.totalNetFreightRevenue || 0) +
      Number(totalCalculatedRates.totalLaytimeRevenueRevenue || 0);
    totalCalculatedRates.totalNetExpense =
      Number(totalCalculatedRates.totalNetFreightExpense || 0) +
      Number(totalCalculatedRates.totalLaytimeRevenueExpense || 0);
    totalCalculatedRates.netProfit =
      Number(totalCalculatedRates.totalNetFreight || 0) +
      Number(totalCalculatedRates.totalLaytimeProfit || 0);
    currentdata.totalCalculatedRates = totalCalculatedRates;
    setCalculatorData(currentdata);
  };

  const sendCalculationRequest = async () => {
    await actions
      .updateCargoCargoDetails(calculatorData?._id, {
        ...calculatorData,
        organizationId,
      })
      .then((res) => {
        toastSuccess("Details updated successfully");
        setLoader(false);
      })
      .catch(() => {
        setLoader(false);
      });
  };

  const onChangeRevenueOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let customerCargoList = [...calculatorData.customerCargo?.cargoList];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value,
      );
      customerCargoList[index]["terms"] = value;
      customerCargoList[index]["factor"] =
        (termFactor && termFactor.value) || 0;
    } else {
      customerCargoList[index][name] = value;
      if (name === "laytimeIncurred") {
        customerCargoList[index]["laytimeIncurred_edited"] = true;
      }
    }
    if (calculatorData?.freightModeRevenue === "Single Freight") {
      if (name === "freight") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.freight = value;
          }
        });
      } else if (name === "adcom") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.adcom = value;
          }
        });
      } else if (name === "other") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.other = value;
          }
        });
      } else if (name === "brokerage") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.brokerage = value;
          }
        });
      }
    }
    let updatedCalculatorData = {
      ...calculatorData,
      customerCargo: {
        ...calculatorData.customerCargo,
        cargoList: customerCargoList,
      },
    };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangeExpenseOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let customerCargoList = [...calculatorData.vendorCargo?.cargoList];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value,
      );
      customerCargoList[index]["terms"] = value;
      customerCargoList[index]["factor"] =
        (termFactor && termFactor.value) || 0;
    } else {
      customerCargoList[index][name] = value;
      if (name === "laytimeIncurred") {
        customerCargoList[index]["laytimeIncurred_edited"] = true;
      }
    }

    if (calculatorData?.freightModeExpense === "Single Freight") {
      if (name === "freight") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.freight = value;
          }
        });
      } else if (name === "adcom") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.adcom = value;
          }
        });
      } else if (name === "other") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.other = value;
          }
        });
      } else if (name === "brokerage") {
        customerCargoList?.forEach((item) => {
          if (item?.operation?.toLowerCase() === "loading") {
            item.brokerage = value;
          }
        });
      }
    }
    let updatedCalculatorData = {
      ...calculatorData,
      vendorCargo: {
        ...calculatorData.vendorCargo,
        cargoList: customerCargoList,
      },
    };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangePortOperations = (index, e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let vesselVoyageData = [...calculatorData.vesselVoyageData];

    if (name === "terms") {
      const termFactor = termsCoEfficientTable.find(
        (item) => item.label === value,
      );
      vesselVoyageData[index]["terms"] = value;
      vesselVoyageData[index]["factor"] = (termFactor && termFactor.value) || 0;
    } else {
      vesselVoyageData[index][name] = value;
    }
    if (datename === "departureTime" || datename === "arrivalTime") {
      if (
        vesselVoyageData[index]?.departureTime &&
        vesselVoyageData[index]?.arrivalTime
      ) {
        vesselVoyageData[index].portStay = calculateDifference(
          vesselVoyageData[index]?.arrivalTime,
          vesselVoyageData[index]?.departureTime,
        );
      }
    }
    let updatedCalculatorData = { ...calculatorData, vesselVoyageData };
    setCalculatorData(updatedCalculatorData);
    calculate(updatedCalculatorData);
  };

  const onChangeFields = (e, isDate = false, datename) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }

    let calculatorDetailsData = { ...calculatorData };
    if (name === "freightModeRevenue") {
      if (value === "Single Freight") {
        let firstLoadPort = {}; // reset values to first loading port

        const cargoListRevenue =
          calculatorDetailsData?.customerCargo?.cargoList?.map(
            (item, index) => {
              if (
                !Object.keys(firstLoadPort).length &&
                item.operation === "Loading"
              )
                firstLoadPort = {
                  freight: item.freight,
                  adcom: item.adcom,
                  other: item.other,
                  brokerage: item.brokerage,
                };
              if (index !== 0 && item.operation === "Loading") {
                return {
                  ...item,
                  ...firstLoadPort,
                };
              }
              return item;
            },
          );
        calculatorDetailsData.customerCargo.cargoList = cargoListRevenue;
      } else if (value === "Multi Freight") {
      }
    }
    if (name === "freightModeExpense") {
      if (value === "Single Freight") {
        let firstLoadPort = {}; // reset values to first loading port

        const cargoListRevenue =
          calculatorDetailsData?.vendorCargo?.cargoList?.map((item, index) => {
            if (
              !Object.keys(firstLoadPort).length &&
              item.operation === "Loading"
            )
              firstLoadPort = {
                freight: item.freight,
                adcom: item.adcom,
                other: item.other,
                brokerage: item.brokerage,
              };
            if (index !== 0 && item.operation === "Loading") {
              return {
                ...item,
                ...firstLoadPort,
              };
            }
            return item;
          });
        calculatorDetailsData.vendorCargo.cargoList = cargoListRevenue;
      } else if (value === "Multi Freight") {
      }
    }
    calculatorDetailsData[name] = value;
    setCalculatorData(calculatorDetailsData);
    calculate(calculatorDetailsData);
  };

  const onChangeModelFields = (
    e,
    isDate = false,
    datename,
    cargocargo = "customerCargo",
  ) => {
    let value = "";
    let name = "";
    if (isDate) {
      value = e;
      name = datename;
    } else {
      value = e.target?.value;
      name = e.target?.name;
    }
    let calculatorDetailsData = { ...calculatorData?.[cargocargo] };
    calculatorDetailsData[name] = value;
    let calculatorDataDetails = { ...calculatorData };
    calculatorDataDetails[cargocargo] = calculatorDetailsData;
    setCalculatorData(calculatorDataDetails);
  };
  // ── Port add / delete (syncs all 3 tables) ──────────────────────────────
  const defaultVoyageRow = (operation = "Loading") => ({
    operation,
    port: "",
    min: 0,
    max: 0,
    cargo: "",
    stowFactor: 0,
    laycanStartDate: null,
    laycanEndDate: null,
    actualCargoQty: 0,
    arrivalTime: null,
    departureTime: null,
    portStay: 0,
  });

  const defaultCargoRow = (operation = "Loading") => ({
    operation,
    port: "",
    rate: 0,
    terms: "SHINC",
    factor: 1,
    turnTime: 0,
    freight: 0,
    adcom: 0,
    other: 0,
    brokerage: 0,
    account: "",
    demurrageRate: 0,
    despatchRate: 0,
    additionalRevenue: 0,
    additionalExpense: 0,
    laytimeIncurred: "",
  });

  const onAddPort = (afterIndex) => {
    const insertAfter = typeof afterIndex === "number" ? afterIndex : (calculatorData?.vesselVoyageData?.length ?? 0) - 1;
    const newVoyage = [...(calculatorData?.vesselVoyageData || [])];
    newVoyage.splice(insertAfter + 1, 0, defaultVoyageRow("Discharging"));
    const newCustList = [...(calculatorData?.customerCargo?.cargoList || [])];
    newCustList.splice(insertAfter + 1, 0, defaultCargoRow("Discharging"));
    const newVendList = [...(calculatorData?.vendorCargo?.cargoList || [])];
    newVendList.splice(insertAfter + 1, 0, defaultCargoRow("Discharging"));
    const updatedData = {
      ...calculatorData,
      vesselVoyageData: newVoyage,
      customerCargo: { ...calculatorData?.customerCargo, cargoList: newCustList },
      vendorCargo: { ...calculatorData?.vendorCargo, cargoList: newVendList },
    };
    setCalculatorData(updatedData);
    calculate(updatedData);
  };

  const onDeletePort = (index) => {
    const updatedData = {
      ...calculatorData,
      vesselVoyageData: (calculatorData?.vesselVoyageData || []).filter((_, i) => i !== index),
      customerCargo: {
        ...calculatorData?.customerCargo,
        cargoList: (calculatorData?.customerCargo?.cargoList || []).filter((_, i) => i !== index),
      },
      vendorCargo: {
        ...calculatorData?.vendorCargo,
        cargoList: (calculatorData?.vendorCargo?.cargoList || []).filter((_, i) => i !== index),
      },
    };
    setCalculatorData(updatedData);
    calculate(updatedData);
  };

  const onChangeCalculatorData = (updatedData) => {
    setCalculatorData(updatedData);
    calculate(updatedData);
  };

  const onClickCopyToMyCargo = () => {
    setCopyConfirm(!isCopyConfirm);
    setSingleCargoData(calculatorData ? calculatorData : "");
    setShareLabel("");
  };
  const onCopySaveClick = async () => {
    if (!shareLabel || !getSingleCargoData || !organizationId) return;
    let { _id, ...datamain } = getSingleCargoData;
    datamain.access = "private";
    datamain.organizationId = organizationId;
    datamain.cargoCargoName = shareLabel;
    await addCargoCargoDetails(datamain);
    setCopyConfirm(false);
    setShareLabel("");
  };

  const savedVesselValue = React.useMemo(() => {
    if (calculatorData?.performingVessel) {
      let savedVesselObj = {};
      try {
        savedVesselObj = JSON.parse(calculatorData.performingVessel);
      } catch (e) { }
      return {
        ...savedVesselObj,
        vesselLabel: `${savedVesselObj.vesselName} (${savedVesselObj.vesselDwt || 0})`,
        vessel: calculatorData.performingVessel,
      };
    }
    return null;
  }, [calculatorData?.performingVessel]);

  return (
    <Grid className="calculator-section min-h-[calc(100vh-60px)] px-0 md:px-5 py-5">
      <Grid item xs={12}>
        <Grid>
          <Grid item xs={12}>
            <div className="quick-menu-bar d-flex justify-end">
              <ActionButtonsCargoCargo
                onClickCalculateAndSave={sendCalculationRequest}
                calculatorData={calculatorData}
                onClickCopyToMyCargo={onClickCopyToMyCargo}
              />
            </div>
            <div className="operation-input-div pb-2 flex items-center">
              <span style={{ marginRight: 8 }}>Performing Vessel : </span>
              {(() => {
                const currentVesselValue = selectedVessel === "cleared" ? null : (selectedVessel || savedVesselValue);

                const hasNewSelection = selectedVessel !== null;
                const hasSavedSelection = savedVesselValue && !hasNewSelection;

                const inputWidth = currentVesselValue?.vesselLabel ? Math.max(170, currentVesselValue.vesselLabel.length * 6.2 + 55) : 170;

                return (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Autocomplete
                      options={vesselOptions.length > 0 ? vesselOptions : (currentVesselValue ? [currentVesselValue] : [])}
                      value={currentVesselValue}
                      size="small"
                      style={{ width: inputWidth, transition: 'width 0.2s ease-in-out' }}
                      classes={{ paper: "!w-max !min-w-[170px]" }}
                      ListboxProps={{ className: "scroll-thin max-h-[400px]", style: { minWidth: "max-content", whiteSpace: "nowrap", overflowY: "auto" } }}
                      getOptionLabel={(option) => option.vesselLabel || ""}
                      getOptionSelected={(option, value) => option.vesselLabel === value.vesselLabel}
                      className="autocomplete-mui bg-white"
                      onChange={(e, value) => {
                        setSelectedVessel(value === null ? "cleared" : value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Search vessel…"
                          onChange={(e) => delayVesselSearch(e.target.value)}
                          size="small"
                          inputProps={{
                            ...params.inputProps,
                            style: { ...params.inputProps.style, fontSize: "12px", textOverflow: "ellipsis" }
                          }}
                          InputProps={{
                            ...params.InputProps,
                            style: { ...params.InputProps.style, fontSize: "12px" },
                            endAdornment: (
                              <React.Fragment>
                                {isVesselLoading ? (
                                  <CircularProgress color="inherit" size={15} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                    {currentVesselValue && currentVesselValue !== "cleared" && (
                      <VisibilityIcon
                        style={{ cursor: 'pointer', fontSize: 24, color: '#313C4C', marginLeft: 10, marginRight: hasNewSelection ? 0 : 8 }}
                        onClick={() => {
                          if (hasSavedSelection) {
                            setPreviewVessel(null);
                            setShowVesselModal(true);
                          } else {
                            const option = currentVesselValue;
                            const vesselConsumptions = mapVesselConsumptions(option.vesselData);
                            const previewInnerVessel = {
                              vesselName: option.vesselName,
                              vesselDwt: option.vesselDwt || option.vesselData?.vesselDwt || option.vesselData?.DWT || option.vesselData?.dwt || 0,
                              vesselIMO: option.vesselData?.IMO || 0,
                              vesselNRT: option.vesselData?.NRT || 0,
                              vesselMMSI: option.vesselData?.MMSI || 0,
                              vesselTPC: option.vesselData?.TPC || 0,
                              vesselGears: option.vesselData?.Gears || 0,
                              vesselGrabs: option.vesselData?.Grabs || 0,
                              vesselFlag: option.vesselData?.Flag || 0,
                              vesselDraftS: option.vesselData?.Draft || 0,
                              vesselClass: option.vesselData?.Class || 0,
                              vesselBuilt: option.vesselData?.built || 0,
                              vesselGrainCap: option.vesselData?.grain || 0,
                              vesselLOA: option.vesselData?.LOA || 0,
                              vesselBeam: option.vesselData?.Beam || 0,
                              vesselGRT: option.vesselData?.GRT || 0,
                              vesselLightShip: option.vesselData?.light_ship || 0,
                              vesselBaleCap: option.vesselData?.bale_capacity || 0,
                              vesselBalComb1Selected: option.vesselData?.BalComb1 || false,
                              vesselBalComb2Selected: option.vesselData?.BalComb2 || false,
                              vesselBalComb3Selected: option.vesselData?.BalComb3 || false,
                              vesselBalComb4Selected: option.vesselData?.BalComb4 || false,
                              vesselLadComb1Selected: option.vesselData?.LadComb1 || false,
                              vesselLadComb2Selected: option.vesselData?.LadComb2 || false,
                              vesselLadComb3Selected: option.vesselData?.LadComb3 || false,
                              vesselLadComb4Selected: option.vesselData?.LadComb4 || false,
                              vesselExtraDetails: {},
                              ...vesselConsumptions,
                            };

                            setPreviewVessel(previewInnerVessel);
                            setShowVesselModal(true);
                          }
                        }}
                      />
                    )}
                    {hasNewSelection && (
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          let performingVesselString = "";
                          if (selectedVessel && selectedVessel !== "cleared") {
                            const vesselConsumptions = mapVesselConsumptions(selectedVessel.vesselData);

                            // Check if existing vessel string exists to preserve port if any
                            let existingVessel = {};
                            try {
                              existingVessel = JSON.parse(calculatorData?.performingVessel || "{}");
                            } catch (e) { }

                            const innerVessel = {
                              vesselName: selectedVessel.vesselName,
                              vesselDwt: selectedVessel.vesselDwt || selectedVessel.vesselData?.vesselDwt || selectedVessel.vesselData?.DWT || selectedVessel.vesselData?.dwt || 0,
                              vesselIMO: selectedVessel.vesselData?.IMO || 0,
                              vesselNRT: selectedVessel.vesselData?.NRT || 0,
                              vesselMMSI: selectedVessel.vesselData?.MMSI || 0,
                              vesselTPC: selectedVessel.vesselData?.TPC || 0,
                              vesselGears: selectedVessel.vesselData?.Gears || 0,
                              vesselGrabs: selectedVessel.vesselData?.Grabs || 0,
                              vesselFlag: selectedVessel.vesselData?.Flag || 0,
                              vesselDraftS: selectedVessel.vesselData?.Draft || 0,
                              vesselClass: selectedVessel.vesselData?.Class || 0,
                              vesselBuilt: selectedVessel.vesselData?.built || 0,
                              vesselGrainCap: selectedVessel.vesselData?.grain || 0,
                              vesselLOA: selectedVessel.vesselData?.LOA || 0,
                              vesselBeam: selectedVessel.vesselData?.Beam || 0,
                              vesselGRT: selectedVessel.vesselData?.GRT || 0,
                              vesselLightShip: selectedVessel.vesselData?.light_ship || 0,
                              vesselBaleCap: selectedVessel.vesselData?.bale_capacity || 0,
                              port: existingVessel.port,
                              vesselBalComb1Selected: selectedVessel.vesselData?.BalComb1 || false,
                              vesselBalComb2Selected: selectedVessel.vesselData?.BalComb2 || false,
                              vesselBalComb3Selected: selectedVessel.vesselData?.BalComb3 || false,
                              vesselBalComb4Selected: selectedVessel.vesselData?.BalComb4 || false,
                              vesselLadComb1Selected: selectedVessel.vesselData?.LadComb1 || false,
                              vesselLadComb2Selected: selectedVessel.vesselData?.LadComb2 || false,
                              vesselLadComb3Selected: selectedVessel.vesselData?.LadComb3 || false,
                              vesselLadComb4Selected: selectedVessel.vesselData?.LadComb4 || false,
                              vesselExtraDetails: {},
                              ...vesselConsumptions,
                            };
                            performingVesselString = JSON.stringify(innerVessel);
                          }

                          const updatedData = {
                            ...calculatorData,
                            performingVessel: performingVesselString
                          };
                          setCalculatorData(updatedData);
                          calculate(updatedData);
                          actions.updateCargoCargoDetails(updatedData?._id, {
                            ...updatedData,
                            organizationId,
                          }).then(() => {
                            toastSuccess("Vessel details updated successfully");
                            setSelectedVessel(null);
                          }).catch(() => { });
                        }}
                        style={{ textTransform: "capitalize", marginLeft: 8 }}
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                );
              })()}
            </div>
          </Grid>
          <div className="middle-section-grid d-flex">
            <Grid container alignItems="flex-start">
              <Grid item xs={10} className="pr-1">
                <CargoCargoPortOperations
                  calculatorData={calculatorData}
                  setCalculatorData={setCalculatorData}
                  onChangePortOperations={onChangePortOperations}
                />
              </Grid>
              <Grid item xs={2}>
                {calculatorData && (
                  <NetProfitResult
                    label="Net Profit Result"
                    // calculationErrors={calculationErrors}
                    calculatorData={calculatorData}
                  />
                )}
              </Grid>
            </Grid>
          </div>
          <div className="pt-3 pb-1">
            <Grid item xs={12}>
              <div className="pb-1">
                <span style={{ fontSize: "16px", fontWeight: 500 }}>
                  Revenue Side :{" "}
                </span>
              </div>
              <div className="d-flex">
                <div className="operation-input-div cargo-cargo-div pb-1">
                  <span>Freight Mode: </span>
                  <select
                    id="freightModeRevenue"
                    value={calculatorData?.freightModeRevenue}
                    name="freightModeRevenue"
                    onChange={(e) => onChangeFields(e)}
                  >
                    <option key={0} value="Single Freight">
                      Single Freight
                    </option>
                    <option key={1} value="Multiple Freight">
                      Multiple Freight
                    </option>
                  </select>
                </div>
                <div
                  className="operation-input-div cargo-cargo-div pb-1 pl-2 underline"
                  onClick={() => setOpenCargoDetails("customerCargo")}
                >
                  Cargo Details
                </div>
              </div>
            </Grid>
            <div className="middle-section-grid d-flex">
              <Grid container alignItems="flex-start">
                <Grid item xs={10} className="pr-1">
                  <Revenue
                    calculatorData={calculatorData}
                    setCalculatorData={setCalculatorData}
                    onChangeRevenueOperations={onChangeRevenueOperations}
                    freightMode={calculatorData?.freightModeRevenue}
                  />
                </Grid>
                <Grid item xs={2}>
                  {calculatorData && (
                    <CargoCargoResult
                      label="Customer Side (Revenue):"
                      isCustomerSide
                      calculatorData={calculatorData}
                    // calculationErrors={calculationErrors}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
          <div className="pt-2 pb-2">
            <Grid item xs={12}>
              <div className="pb-1">
                <span style={{ fontSize: "16px", fontWeight: 500 }}>
                  Expense Side :{" "}
                </span>
              </div>
              <div className="d-flex">
                <div className="operation-input-div cargo-cargo-div pb-1">
                  <span>Freight Mode: </span>

                  <select
                    value={calculatorData?.freightModeExpense}
                    name="freightModeExpense"
                    onChange={(e) => onChangeFields(e)}
                  >
                    <option key={0} value="Single Freight">
                      Single Freight
                    </option>
                    <option key={0} value="Multiple Freight">
                      Multiple Freight
                    </option>
                  </select>
                </div>
                <div
                  className="operation-input-div cargo-cargo-div pb-1 pl-2 underline"
                  onClick={() => setOpenCargoDetails("vendorCargo")}
                >
                  Cargo Details
                </div>
              </div>
            </Grid>
            <div className="middle-section-grid d-flex">
              <Grid container alignItems="flex-start">
                <Grid item xs={10} className="pr-1">
                  <Expense
                    calculatorData={calculatorData}
                    setCalculatorData={setCalculatorData}
                    onChangeExpenseOperations={onChangeExpenseOperations}
                    freightMode={calculatorData?.freightModeExpense}
                  />
                </Grid>
                <Grid item xs={2}>
                  {calculatorData && (
                    <CargoCargoResult
                      label="Vendor Side (Expense)"
                      calculatorData={calculatorData}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          </div>

          <CustomAddModal
            open={!!openCargoDetails}
            handleClose={() => setOpenCargoDetails(false)}
            maxWidth="lg"
            title="Cargo Details"
            saveLabel="Save"
            onSubmitConfirm={() => cargoDetailsRef.current?.handleSaveRequest()}
          >
            <CargoDetails
              ref={cargoDetailsRef}
              calculatorData={calculatorData}
              activeSide={openCargoDetails || "customerCargo"}
              onSave={(draftData) => {
                setCalculatorData(draftData);
                calculate(draftData);
                actions.updateCargoCargoDetails(draftData?._id, {
                  ...draftData,
                  organizationId,
                }).then(() => {
                  toastSuccess("Details updated successfully");
                }).catch(() => { });
                setOpenCargoDetails(false);
              }}
            />
          </CustomAddModal>

          <CustomAddModal
            open={showVesselModal}
            handleClose={() => {
              setShowVesselModal(false);
              setPreviewVessel(null);
            }}
            onSubmitConfirm={() => {
              if (vesselModelRef.current) {
                vesselModelRef.current.submit();
              }
            }}
            maxWidth="md"
            title="View Vessel Details"
            saveLabel="Save"
          >
            <VesselViewModel
              ref={vesselModelRef}
              currentContract={(() => {
                const vesselStr = previewVessel ? JSON.stringify(previewVessel) : (calculatorData?.performingVessel || "{}");
                let parsed = {};
                try {
                  parsed = JSON.parse(vesselStr);
                } catch (e) { }
                return {
                  ...parsed,
                  vessel: vesselStr,
                };
              })()}
              isFromCreateVessel={!previewVessel}
              isOps={false}
              isViewOnly={false}
              setLoader={setLoader}
              onSaveOverride={(updatedVal) => {
                let parsedSelectedVessel = {};
                try {
                  parsedSelectedVessel = JSON.parse(updatedVal.vessel || "{}");
                } catch (e) { }

                const { vessel: _v, ...restContractFields } = updatedVal;

                const fullPerformingVesselObj = {
                  ...parsedSelectedVessel,
                  ...restContractFields,
                };

                const performingVesselString = JSON.stringify(fullPerformingVesselObj);

                const draftData = {
                  ...calculatorData,
                  performingVessel: performingVesselString
                };
                setCalculatorData(draftData);
                calculate(draftData);
                actions.updateCargoCargoDetails(draftData?._id, {
                  ...draftData,
                  organizationId,
                }).then(() => {
                  toastSuccess("Vessel details updated successfully");
                  setShowVesselModal(false);
                  setPreviewVessel(null);
                  setSelectedVessel(null);
                }).catch(() => { });
              }}
            />
          </CustomAddModal>

          <CustomAddModal
            open={isCopyConfirm}
            handleClose={onClickCopyToMyCargo}
            onSubmitConfirm={onCopySaveClick}
            maxWidth="xs"
            saveLabel="Create"
            title="Copy to My Cargo"
          >
            <ShareWithOrg
              value={shareLabel}
              onChange={(e) => setShareLabel(e.target.value)}
              placeholder="Enter CargoCargo name*"
              label="My copy name"
              guidanceTitle="Copy this cargo estimate"
              guidance="Create a separate personal copy of this cargo estimate. Find it in Cargo Cargo Estimation → My Cargo."
            />
          </CustomAddModal>
        </Grid>
      </Grid>
    </Grid >
  );
}
